var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisuClimateMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 224,
    viewBox: "0 0 285 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284.59,
    height: 224,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 188H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 156H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 124H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 92H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 60H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 90.357C22 90.357 52.5013 180.889 83.3342 180.889C114.167 180.889 114.167 182.638 145 182.638C175.501 182.638 175.501 110.038 206.334 110.038C237.167 110.038 268 21.2554 268 21.2554",
    stroke: "#F6AD55",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 111.787C22 111.787 52.5013 93.8558 83.3342 93.8558C114.167 93.8558 114.167 64.5532 145 64.5532C175.501 64.5532 175.501 73.7376 206.334 73.7376C237.167 73.7376 268 106.539 268 106.539",
    stroke: "#4FD1C5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0C17 0 52.5013 126.914 83.3342 126.914C114.167 126.914 114.167 185 145 185C175.501 185 175.501 183.24 206.334 183.24C237.167 183.24 268 73.669 268 73.669",
    stroke: "#7F9CF5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.795,
    cy: 216,
    r: 8,
    fill: "#7F9CF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.795,
    y: 212.5,
    width: 64,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.795,
    cy: 216,
    r: 8,
    fill: "#4FD1C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.795,
    y: 212.5,
    width: 52,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.795,
    cy: 216,
    r: 8,
    fill: "#F6AD55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.795,
    y: 212.5,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284.59,
    height: 224,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245,
    height: 16,
    fill: "white",
    transform: "translate(19.795 208)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisuClimateMobile);
export default __webpack_public_path__ + "static/media/visu_climate_mobile.f1da21f3327c91bfd9c70cfacf677b30.svg";
export { ForwardRef as ReactComponent };